import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  "prevent-expand": ""
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SourcePopover = _resolveComponent("SourcePopover")

  return ($options.source)
    ? (_openBlock(), _createBlock(_component_SourcePopover, {
        key: 0,
        ref: "popover",
        data: $options.source,
        disabled: $props.disabled,
        placement: "bottom",
        onHide: _cache[0] || (_cache[0] = $event => ($data.popup_visible = false)),
        onShow: _cache[1] || (_cache[1] = $event => ($data.popup_visible = true))
      }, {
        default: _withCtx(() => [
          _createElementVNode("sup", {
            "prevent-expand": "",
            class: _normalizeClass({pointer: !$props.disabled && !$data.popup_visible, focused: $data.popup_visible})
          }, _toDisplayString($props.num), 3 /* TEXT, CLASS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data", "disabled"]))
    : (_openBlock(), _createElementBlock("sup", _hoisted_1, " E "))
}